module.exports = __webpack_public_path__ + "img/car-front.ab216c3.svg";